import React from 'react';
import { Gap, Gutter, StatePill, Text } from '@common/components';
import { Colors, ColorsType } from '@common/tokens';

type StatusType =
  | 'cancelled'
  | 'cleared'
  | 'completed'
  | 'working'
  | 'starting'
  | 'onboarding';

export function AssignmentStatusTag({
  status,
  neverStarted,
  listItemsCompleted,
  listItemsTotal,
}: {
  status: StatusType;
  neverStarted: boolean;
  listItemsCompleted: number;
  listItemsTotal: number;
}) {
  const textColor: Record<StatusType, ColorsType> = {
    cancelled: 'rubyRed',
    cleared: 'grassDarkest',
    completed: 'white',
    working: 'white',
    starting: 'white',
    onboarding: 'white',
  };

  return (
    <>
      <span className="assignment-status-tag">
        <Gap>
          <StatePill className={`assignment-tag assignment-tag-${status}`}>
            <Text
              size="sm"
              transform="capitalize"
              color={textColor[status] as ColorsType}
            >
              {status}
            </Text>
            {listItemsTotal > 0 && (
              <Gutter fit size="xs" direction="left">
                {listItemsCompleted}/{listItemsTotal}
              </Gutter>
            )}
          </StatePill>
          {neverStarted && (
            <StatePill className="assignment-tag assignment-tag-cancelled">
              Never Started
            </StatePill>
          )}{' '}
        </Gap>
      </span>
      <style jsx>
        {`
          .assignment-status-tag
            :global(
              .assignment-tag-onboarding,
              .assignment-tag-onboarding:hover
            ) {
            color: ${Colors.white};
            background-color: ${Colors.harvestGold};
            border-color: ${Colors.harvestGold};
          }
          .assignment-status-tag
            :global(.assignment-tag-starting, .assignment-tag-starting:hover) {
            color: ${Colors.white};
            background-color: ${Colors.grassDarkest};
            border-color: ${Colors.grassDarkest};
          }
          .assignment-status-tag
            :global(.assignment-tag-working, .assignment-tag-working:hover) {
            color: ${Colors.white};
            background-color: ${Colors.grass};
            border-color: ${Colors.grass};
          }
          .assignment-status-tag
            :global(
              .assignment-tag-completed,
              .assignment-tag-completed:hover
            ) {
            color: ${Colors.white};
            background-color: ${Colors.grassDarkest};
            border-color: ${Colors.grassDarkest};
          }
          .assignment-status-tag
            :global(
              .assignment-tag-cancelled,
              .assignment-tag-cancelled:hover
            ) {
            color: ${Colors.rubyRed};
            background-color: ${Colors.rubyRedLight};
            border-color: ${Colors.rubyRedLight};
          }
          .assignment-status-tag
            :global(.assignment-tag-cleared, .assignment-tag-cleared:hover) {
            color: ${Colors.grassDarkest};
            background-color: ${Colors.grassLighter};
            border-color: ${Colors.grassLighter};
          }
        `}
      </style>
    </>
  );
}
